import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ImageCropperComponent, ImageCroppedEvent, LoadedImage} from "ngx-image-cropper";

@Component({
  selector: 'app-image-picker',
  templateUrl: './image-picker.component.html',
  styleUrls: ['./image-picker.component.scss']
})
export class ImagePickerComponent implements OnInit {

  @Input() aspectRatio: number = 1920/720

  @Output() croppedImageBase64 = new EventEmitter<string>();
  @Output() imageName = new EventEmitter<string>();

  public imageChangedEvent: any = '';

  public onImageCropped(event: ImageCroppedEvent) {
    if(event.base64){
      this.croppedImageBase64.emit(event.base64)
    }
  }

  public onImageLoaded() {
    // ...
  }

  public onCropperReady() {
    // ...
  }

  public onLoadImageFailed() {
    // ...
  }
  public fileChangeEvent(event: any): void {
    console.log('hehe', event.target.files[0])
    if (event?.target?.files[0]?.name) {
      this.imageChangedEvent = event;
      this.imageName.emit(event.target.files[0].name)
    }
  }


  constructor(
  ) {
  }

  ngOnInit(): void {
  }

}
